<template>
  <div>
<NavbarEmpresa/>
<EmpresaBanner/>
<MiInter/>
<EmpresasAsociadas/>
|<FooterSection/>
  </div>
</template>

<script>
import EmpresasAsociadas from '@/components/EmpresaView/EmpresasAsociadas.vue';
import NavbarEmpresa from '@/components/EmpresaView/NavbarEmpresa.vue';
import EmpresaBanner from '@/components/EmpresaView/EmpresaBanner.vue';
import MiInter from '@/components/EmpresaView/MiInter.vue';
import FooterSection from '@/components/FooterSection.vue';



export default {
  name: 'EmpresaView',
  components: {
   NavbarEmpresa,
   FooterSection,
   EmpresaBanner,
   MiInter,
   EmpresasAsociadas,

  }
}
</script>